/**
 * 相性ドラマの動画の、場面の注文の既定（doc/VIDEO.md）。管理者の画面と利用者のリクエストの欄に最初から入れておく。
 * 場面を決め打ちせず、2 人の診断タイプの違いから Gemini に話を考えさせる。
 * サーバ（services/api/src/lib/video.ts の DEFAULT_VIDEO_PROMPT）と同じ文にしておく（空欄で送るとサーバがこれを使う）。
 */
export const DEFAULT_VIDEO_PROMPT = 'この 2 人の診断タイプの違いから、思わず笑ってしまう身近なエピソードを考えて作ってください。場面も話の筋もおまかせします。';
